import { useQuery } from "react-query";
import { useSelector } from "react-redux";

const useSplitProfileList = (
	getSplitProfileList,
	getSplitProfilePage,
	getSplitProfileSortBy,
	getSplitProfileSortDescending,
	agentId,
) => {
	const page = useSelector(getSplitProfilePage);
	const sortBy = useSelector(getSplitProfileSortBy);
	const sortDescending = useSelector(getSplitProfileSortDescending);

	const fetchSplitProfileList = () => {
		return getSplitProfileList({
			page,
			sortBy,
			sortDescending,
			agentId,
		});
	};

	const queryResult = useQuery(
		["splitProfileList", { page, sortBy, sortDescending }],
		fetchSplitProfileList,
		{
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useSplitProfileList;
